/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Bilingual_EnglishInputs */

const en_bilingual_english = /** @type {(inputs: Bilingual_EnglishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bilingual English`)
};

const fr_bilingual_english = /** @type {(inputs: Bilingual_EnglishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anglais bilingue`)
};

const de_bilingual_english = /** @type {(inputs: Bilingual_EnglishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zweisprachig Englisch`)
};

const it_bilingual_english = /** @type {(inputs: Bilingual_EnglishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inglese bilingue`)
};

const ru_bilingual_english = /** @type {(inputs: Bilingual_EnglishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Двуязычный английский`)
};

const es_bilingual_english = /** @type {(inputs: Bilingual_EnglishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inglés bilingüe`)
};

const zh_cn2_bilingual_english = /** @type {(inputs: Bilingual_EnglishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`双语英语`)
};

const ja_bilingual_english = /** @type {(inputs: Bilingual_EnglishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`バイリンガル英語`)
};

const hi_bilingual_english = /** @type {(inputs: Bilingual_EnglishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`द्विभाषी अंग्रेजी`)
};

const pt_pt2_bilingual_english = /** @type {(inputs: Bilingual_EnglishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inglês bilíngue`)
};

/**
* | output |
* | --- |
* | "Bilingual English" |
*
* @param {Bilingual_EnglishInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const bilingual_english = /** @type {((inputs?: Bilingual_EnglishInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Bilingual_EnglishInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_bilingual_english(inputs)
	if (locale === "de") return de_bilingual_english(inputs)
	if (locale === "it") return it_bilingual_english(inputs)
	if (locale === "ru") return ru_bilingual_english(inputs)
	if (locale === "es") return es_bilingual_english(inputs)
	if (locale === "zh-CN") return zh_cn2_bilingual_english(inputs)
	if (locale === "ja") return ja_bilingual_english(inputs)
	if (locale === "hi") return hi_bilingual_english(inputs)
	if (locale === "pt-PT") return pt_pt2_bilingual_english(inputs)
	return en_bilingual_english(inputs)
});